import { FinanceRepository } from '@lib/api/repository/finance/finance.repository';
import { PayoutDestinationInput, WithdrawalInput } from '@lib/types';
import { AdminPageFilters } from '@lib/types/admin-page';

export default class FinanceService {
  listAdminPage(filters: AdminPageFilters, signal?: AbortSignal) {
    return this.repository.listAdminPage(filters, signal);
  }

  constructor(private repository: FinanceRepository) {}

  findWithdrawalByKey(key: string, signal?: AbortSignal) {
    return this.repository.findWithdrawalByKey(key, signal);
  }

  quoteWithdrawal(requestedCents: number) {
    return this.repository.quoteWithdrawal(requestedCents);
  }

  getBalance(signal?: AbortSignal) {
    return this.repository.getBalance(signal);
  }

  listLedger(signal?: AbortSignal) {
    return this.repository.listLedger(signal);
  }

  listWithdrawals(signal?: AbortSignal) {
    return this.repository.listWithdrawals(signal);
  }

  requestWithdrawal(input: WithdrawalInput) {
    return this.repository.requestWithdrawal(input);
  }

  listPayoutDestinations(signal?: AbortSignal) {
    return this.repository.listPayoutDestinations(signal);
  }

  createPayoutDestination(input: PayoutDestinationInput) {
    return this.repository.createPayoutDestination(input);
  }

  setDefaultPayoutDestination(destinationId: string) {
    return this.repository.setDefaultPayoutDestination(destinationId);
  }

  deactivatePayoutDestination(destinationId: string) {
    return this.repository.deactivatePayoutDestination(destinationId);
  }

  listAdminWithdrawals(signal?: AbortSignal) {
    return this.repository.listAdminWithdrawals(signal);
  }

  reviewWithdrawal(
    withdrawalId: string,
    approved: boolean,
    note?: string,
  ) {
    return this.repository.reviewWithdrawal(withdrawalId, approved, note);
  }

  finalizeWithdrawal(withdrawalId: string, note?: string) {
    return this.repository.finalizeWithdrawal(withdrawalId, note);
  }
}

